<template>
  <v-navigation-drawer v-model="sideBarDrawer" app clipped>
    <v-list>
      <template v-for="item in items">
        <v-list-group
          :key="item.title"
          v-model="item.active"
          :prepend-icon="item.icon"
          :append-icon="!!item.items ? '$expand' : ''"
          @click="!!item.items || goToPage(item.page)"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="subItem in item.items"
            :key="subItem.title"
            @click="goToPage(subItem.page)"
          >
            <v-list-item-content>
              <v-list-item-title v-text="subItem.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    drawer: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    sideBarDrawer: null,
    items: [
      {
        icon: 'mdi-account-cog',
        title: '會員管理',
        items: [
          {
            title: '會員列表',
            page: 'member-list',
          },
          {
            title: '待審核名單',
            page: 'member-auth-list',
          },
        ],
      },
      {
        icon: 'mdi-store',
        title: '供應商管理',
        items: [
          {
            title: '供應商列表',
            page: 'merchant',
          },
          {
            title: '供應商類別管理',
            page: 'merchantCategoryList',
          },
        ],
      },
      {
        icon: 'mdi-newspaper-variant-outline',
        title: '其他點數管理',
        page: 'otherPointList',
      },
      {
        icon: 'mdi-alpha-c-circle',
        title: '點數換入管理',
        items: [
          {
            title: '換入類別管理',
            page: 'swap-in-point-type-management',
          },
          {
            title: '換入點數列表',
            page: 'swap-in-point-item-list',
          },
          {
            title: '換入序號管理',
            page: 'swap-in-point-vouchers-list',
          },
          {
            title: '點數計算機管理',
            page: 'pointCalculatorList',
          },
        ],
      },
      {
        icon: 'mdi-alpha-c-circle',
        title: '點數換出管理',
        items: [
          {
            title: '換出類別管理',
            page: 'swapOutProductCategoryList',
          },
          {
            title: '商品標籤管理',
            page: 'swapOutProductTagList',
          },
          {
            title: '換出商品管理',
            page: 'swapOutProductList',
          },
          {
            title: '換出序號查詢',
            page: 'swapOutVoucherList',
          },
        ],
      },
      {
        icon: 'mdi-alpha-c-circle',
        title: '虛擬貨幣交易管理',
        items: [
          {
            title: '虛擬貨幣列表',
            page: 'virtualCurrency',
          },
          {
            title: '交易所列表',
            page: 'virtualExchanger',
          },
          {
            title: '設定每日交易門檻',
            page: 'dailyThreshold',
          },
        ],
      },
      {
        icon: 'mdi-alpha-c-circle',
        title: '優惠代碼管理',
        page: 'promotion-code-list',
      },
      {
        icon: 'mdi-newspaper-variant-outline',
        title: '媒體報導管理',
        items: [
          {
            title: '新聞列表',
            page: 'news-list',
          },
          {
            title: '媒體設定',
            page: 'news-media-list',
          },
        ],
      },
      {
        icon: 'mdi-newspaper-variant-outline',
        title: '最新活動管理',
        page: 'event-list',
      },
      {
        icon: 'mdi-newspaper-variant-outline',
        title: '排程推播管理',
        page: 'scheduledMessageList',
      },
      {
        icon: 'mdi-newspaper-variant-outline',
        title: '導購管理',
        page: 'shoppingGuideList',
      },
      {
        icon: 'mdi-newspaper-variant-outline',
        title: '折價券活動列表',
        page: 'couponActivityList',
      },
      {
        icon: 'mdi-newspaper-variant-outline',
        title: '服務更新管理',
        page: 'serviceUpdateList',
      },
      {
        icon: 'mdi-newspaper-variant-outline',
        title: '推薦代碼管理',
        page: 'invitationCodeList',
      },
      {
        icon: 'mdi-newspaper-variant-outline',
        title: '登記回饋活動',
        items: [
          {
            title: '合作廠商管理',
            page: 'shoppingGiveBackMerchantList',
          },
          {
            title: '登記回饋查詢',
            page: 'shoppingGiveBackRequest',
          },
        ],
      },
      {
        icon: 'mdi-newspaper-variant-outline',
        title: '店家每日消費管理',
        page: 'storeSummary',
      },
      {
        icon: 'mdi-newspaper-variant-outline',
        title: '訂單管理',
        page: 'paymentList',
      },
      {
        icon: 'mdi-newspaper-variant-outline',
        title: '行銷報表管理',
        items: [
          {
            title: '換出點數',
            page: 'swapOutPointReport',
          },
          {
            title: '換出商品（純點）',
            page: 'swapOutProductReport',
          },
          {
            title: '線上電支明細（點＋金）',
            page: 'mobilePaymentReport',
          },
          {
            title: '會員換入點數',
            page: 'swapInReport',
          },
          {
            title: '折價券使用列表',
            page: 'swapOutDiscountCouponReport',
          },
          {
            title: '會員點數列表',
            page: 'userPointReport',
          },
          {
            title: 'SP點數產出紀錄',
            page: 'superPointGenerateReport',
          },
        ],
      },
      {
        icon: 'mdi-newspaper-variant-outline',
        title: '首頁設定',
        items: [
          {
            title: 'Web首頁橫幅管理',
            page: 'bannerList',
          },
          {
            title: 'Web首頁顯示產品管理',
            page: 'homeProduct',
          },
          {
            title: 'APP首頁廣告版位管理',
            page: 'appAdCarouselList',
          },
          {
            title: 'APP首頁彈窗廣告管理',
            page: 'appAdPopupList',
          },
          {
            title: 'APP首頁人氣兌換管理',
            page: 'popularProductUrlList',
          },
        ],
      },
      {
        icon: 'mdi-calendar-month-outline',
        title: '任務管理',
        page: 'missionList',
      },
    ],
  }),
  watch: {
    drawer: {
      immediate: true,
      handler(v) {
        this.sideBarDrawer = !v;
      },
    },
  },
  methods: {
    goToPage(name) {
      if (this.$route.name === name) return;
      this.$router.push({ name });
    },
  },
};
</script>

<style>
</style>
